// FAM2 R4: teacher answer about the previous lesson's missions (teacher JWT).

export const MISSION_COMPLETION_API = Object.freeze({
  PREVIOUS: '/mission-completions/previous',
  ANSWER: (lessonId) => `/mission-completions/${lessonId}`,
});

export const MISSION_DIFFICULTY_LEVELS = Object.freeze([1, 2, 3, 4, 5]);

export const MISSION_DIFFICULTY_LABEL = Object.freeze({
  1: 'très faciles',
  2: 'faciles',
  3: 'moyennes',
  4: 'difficiles',
  5: 'très difficiles',
});

// Source of a teacher answer (backend SOURCE_TEACHER).
export const MISSION_SOURCE_TEACHER = 'teacher';

export const MISSION_CHECK_COPY = Object.freeze({
  title: 'Missions du dernier cours',
  question: (date) => `Les missions du cours du ${date} ont-elles été faites ?`,
  yes: 'Oui',
  no: 'Non',
  saved: 'Réponse enregistrée.',
  saveFailed: 'Réponse non enregistrée. Réessayez.',
});
